import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./components/sections/Footer/Footer";
import Presentation from "./components/sections/Presentation/Presentation";
import About from "./components/sections/About/About";
import Projects from "./components/sections/Projects/Projects";
import AllSkills from "./components/sections/Skills/Skills";
import Education from "./components/sections/Education/Education";
import AnimatedBackground from "./components/common/AnimatedBackground";
import Header from "./components/common/Header";
import Blog from "./components/sections/Blog/Blog";
import BlogPost from "./components/sections/Blog/BlogPost";
import BlogList from "./components/sections/Blog/BlogList";
import ContactPage from "./components/sections/Contact/ContactPage";
import NotFound from "./components/sections/NotFound/NotFound";
import SEOHead from "./components/common/SEOHead";
import PrivacyPolicyPage from "./components/sections/Legal/PrivacyPolicyPage";
import TermsPage from "./components/sections/Legal/TermsPage";
import EditorialPolicyPage from "./components/sections/Legal/EditorialPolicyPage";
import AdUnit from "./components/common/AdUnit";

function Home() {
  return (
    <div className="relative w-full min-h-lvh text-white">
      <SEOHead
        title="Franco Martino"
        description="Portfolio profesional de Franco Martino, desarrollador de software y técnico electrónico de Buenos Aires, Argentina. Especializado en React, TypeScript, Python, automatización, IoT y web scraping."
        url="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Person",
          name: "Franco Martino",
          givenName: "Franco",
          familyName: "Martino",
          jobTitle: "Desarrollador de Software",
          description:
            "Desarrollador de software y técnico electrónico especializado en React, TypeScript, Python, automatización e IoT.",
          url: "https://martinofranco.com",
          sameAs: [
            "https://github.com/FrancoMartino",
            "https://www.linkedin.com/in/francomartino/",
          ],
          knowsAbout: [
            "React",
            "TypeScript",
            "Python",
            "JavaScript",
            "C++",
            "Arduino",
            "Tailwind CSS",
            "Web Scraping",
            "Automation",
            "IoT",
          ],
          alumniOf: [
            { "@type": "CollegeOrUniversity", name: "UADE" },
            { "@type": "CollegeOrUniversity", name: "UFASTA" },
          ],
        }}
      />
      <AnimatedBackground />
      <div className="relative max-w-7xl mx-auto flex flex-col w-full sm:px-16 px-8">
        <Presentation />
        <main className="flex flex-col gap-12 pb-4">
          <About />
          <div className="flex lg:flex-row-reverse flex-col gap-8">
            <div className="lg:w-1/3 w-auto flex flex-col gap-8">
              <AllSkills />
              <Education />
            </div>
            <div className="lg:w-2/3 w-auto flex flex-col gap-8">
              <Projects />
            </div>
          </div>
          <AdUnit slot="6805590889" format="horizontal" label="Publicidad" />
          <Blog />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/editorial-policy" element={<EditorialPolicyPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
